<template>

  <template v-if="!isLoading">

    <section class="mb-30 lg:mb-80">

      <div class="container">


        <h1 class="font-bold text-center text-xl lg:text-2xl mb-25 leading-24 lg:leading-28">Configurateur Open</h1>

        <ol class="stepper">

          <li class="step isPrevious" >
            <a @click.prevent="$emit('switchToEtape1');taggage('configurateur_open', 'etapes_tunnel', 'etape_1', { tealium_event: 'select_content' })" href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr">1</span></span>
              <span class="txt">Mobile</span>
            </a>
          </li>

          <li class="step isActive" aria-current="step">
            <a href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr">2</span></span>
              <span class="txt">Forfait mobile</span>
            </a>
          </li>

          <li class="step">
            <a href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr">3</span></span>
              <span class="txt">Connexion</span>
            </a>
          </li>

          <li class="step">
            <a href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr">4</span></span>
              <span class="txt">Offre Internet</span>
            </a>
          </li>

          <li class="step">
            <a href="javascript:void(0)">
              <span class="outerNbr"><span class="nbr"><span class="block w-14 lg:w-24 h-14 lg:h-24 c-grey11"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 20"><path fill="currentColor" fill-rule="evenodd" d="m24.9063 3.3549-13.6551 15.75-.0004-.0002c-.391.4503-.9917.7391-1.6657.7391-.674 0-1.2747-.2888-1.6657-.7391l-.0004.0002-6.8275-7.875.0003-.0003C.7993 10.8926.6239 10.4654.6239 10c0-.5437.2388-1.0358.6249-1.3921l.8535-.7875c.386-.3563.9195-.5766 1.5087-.5766.5302 0 1.015.1789 1.3882.4743l.0003-.0004 4.1589 4.2511L21.781.6888l.0004.0003c.3815-.3303.8944-.5329 1.4588-.5329 1.1784 0 2.1337.8815 2.1337 1.9688 0 .4653-.1754.8926-.4679 1.2296l.0003.0003Z" clip-rule="evenodd"/></svg></span></span></span>
              <span class="txt">Terminé !</span>
            </a>
          </li>

        </ol>
      </div>
    </section>

    <section>
        <div class="container">
          <h2 v-if="data_etape0.field_etape2_titre" class="anchorTitle font-bold lg:text-xl text-center leading-22 lg:leading-24 mb-25 lg:mb-60">{{ data_etape0.field_etape2_titre }}</h2>

          <div v-if="data_etape0.field_etape2_promotion" class="bg-white c-black font-bold p-20 lg:p-30 w-full max-w-950 mb-25 lg:mb-60 mx-auto">
            <div class="bg-blue4 p-10 lg:p-16 dflex gap-10 lg:gap items-start gap">
              <span class="dflex c-blue2 w-24 lg:w-26 shrink-0"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 45 45"><path fill="currentColor" fill-rule="evenodd" d="M28.833 36.432h-11.4v-1.304l.269-.008c.788-.026 1.373-.25 1.74-.666.131-.15.353-.664.353-2.389v-11.51c0-1.64-.229-2.26-.42-2.49-.272-.323-.838-.514-1.681-.565l-.26-.015v-1.318H26.3v15.898c0 1.643.428 2.26.62 2.49.27.324.794.514 1.653.565l.26.015v1.297ZM22.5 6.035a3.8 3.8 0 1 1 0 7.6 3.8 3.8 0 0 1 0-7.6Zm0-5.066C10.609.969.969 10.609.969 22.5c0 11.891 9.64 21.531 21.531 21.531 11.891 0 21.531-9.64 21.531-21.531C44.031 10.609 34.391.969 22.5.969Z" clip-rule="evenodd"/></svg></span>
              <p class="text-sm lg:text-base leading-20 lg:leading-22">{{ data_etape0.field_etape2_promotion }}</p>
            </div>
          </div>
        </div>

        <component :is="forfaitComponent" :recapKey="recapKey" :parcours="parcours" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape3="$emit('switchToEtape3')" @loadDialog="loadDialog" @enableSelect="enableSelect" @loadChooseMultiligne="loadChooseMultiligne" ref="forfaitRef" @incrementRecapKey="recapKey++"/>

        <component :is="forfaitMultiligneComponent" :key="chooseM" :parcours="parcours" :data_etape0="data_etape0" :paragraphId="paragraphId" @loadDialog="loadDialog" @enableSelect="enableSelect" @switchToEtape3="$emit('switchToEtape3')" @loadMultiligne1="loadMultiligne1" @loadMultiligne2="loadMultiligne2" @loadMultiligne3="loadMultiligne3" @loadMultiligne4="loadMultiligne4" @deleteMultiligne1="deleteMultiligne1" @deleteMultiligne2="deleteMultiligne2" @deleteMultiligne3="deleteMultiligne3" @deleteMultiligne4="deleteMultiligne4" @disableMultiligne="disableMultiligne"/>

        <component :is="forfaitAddComponent1" :key="reloadKey1" :recapKey="recapKey" :parcours="parcours" :data_etape0="data_etape0" :multiligne="1" :paragraphId="paragraphId" @loadDialog="loadDialog" @switchToEtape3="$emit('switchToEtape3')" @loadMultiligne1="loadMultiligne1" @loadMultiligne2="loadMultiligne2" @loadMultiligne3="loadMultiligne3" @loadMultiligne4="loadMultiligne4" @deleteMultiligne1="deleteMultiligne1" @deleteMultiligne2="deleteMultiligne2" @deleteMultiligne3="deleteMultiligne3" @deleteMultiligne4="deleteMultiligne4" ref="forfaitRefM" @incrementRecapKey="recapKey++"/>

        <component :is="forfaitAddComponent2" :key="reloadKey2" :recapKey="recapKey" :parcours="parcours" :data_etape0="data_etape0" :multiligne="2" :paragraphId="paragraphId" @loadDialog="loadDialog" @switchToEtape3="$emit('switchToEtape3')" @loadMultiligne1="loadMultiligne1" @loadMultiligne2="loadMultiligne2" @loadMultiligne3="loadMultiligne3" @loadMultiligne4="loadMultiligne4" @deleteMultiligne1="deleteMultiligne1" @deleteMultiligne2="deleteMultiligne2" @deleteMultiligne3="deleteMultiligne3" @deleteMultiligne4="deleteMultiligne4" @incrementRecapKey="recapKey++"/>

        <component :is="forfaitAddComponent3" :key="reloadKey3" :recapKey="recapKey" :parcours="parcours" :data_etape0="data_etape0" :multiligne="3" :paragraphId="paragraphId" @loadDialog="loadDialog" @switchToEtape3="$emit('switchToEtape3')" @loadMultiligne1="loadMultiligne1" @loadMultiligne2="loadMultiligne2" @loadMultiligne3="loadMultiligne3" @loadMultiligne4="loadMultiligne4" @deleteMultiligne1="deleteMultiligne1" @deleteMultiligne2="deleteMultiligne2" @deleteMultiligne3="deleteMultiligne3" @deleteMultiligne4="deleteMultiligne4" @incrementRecapKey="recapKey++"/>

        <component :is="forfaitAddComponent4" :key="reloadKey4" :recapKey="recapKey" :parcours="parcours" :data_etape0="data_etape0" :multiligne="4" :paragraphId="paragraphId" @loadDialog="loadDialog" @switchToEtape3="$emit('switchToEtape3')" @loadMultiligne1="loadMultiligne1" @loadMultiligne2="loadMultiligne2" @loadMultiligne3="loadMultiligne3" @loadMultiligne4="loadMultiligne4" @deleteMultiligne1="deleteMultiligne1" @deleteMultiligne2="deleteMultiligne2" @deleteMultiligne3="deleteMultiligne3" @deleteMultiligne4="deleteMultiligne4" @incrementRecapKey="recapKey++"/>

        <div class="container">
          <div class="dflex justify-center gap-15 lg:gap-30 mb-50 lg:mb-110">
            <button @click.prevent="back();taggage('configurateur_open', 'etape_2', 'annuler', { tealium_event: 'select_content' })" type="button" class="resetmobile btn btn--md btn--fill-light w-full max-w-170">Précédent</button>
            <button @click="loadNext();taggage('configurateur_open', 'etape_2', 'suivant', { tealium_event: 'select_content' });taggage('', '', '', taggageForfait)" type="button" class="nextmobile btn btn--md btn--fill-dark w-full max-w-170" :disabled="!isEnabled">Suivant</button>
          </div>
        </div>

    </section>

    <component :is="forfaitDialog" :key="etapeDialog" :forfaitid="forfaitid" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape3="$emit('switchToEtape3')"/>

  </template>

  <component :is="recapComponent" :key="recapKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')"/>


</template>

<script setup>
import { ref, computed } from 'vue';
import { onMounted, nextTick } from 'vue';
import { taggage, taggageView } from '@/utils/taggage.js';
import Etape2Forfait from './Etape2Forfait.vue';
import Etape2Multiligne from './Etape2Multiligne.vue';
import Etape2ChooseMultiligne from './Etape2ChooseMultiligne.vue';
import Etape2ForfaitDialog from './Etape2ForfaitDialog.vue';
import Etape5Recap from './Etape5Recap.vue';
import { globalStore } from '@/utils/store.js';

globalStore.tag.tealium_event = "product_click";

const data_etape2 = ref({});
const error_etape2 = ref(null);
const etapeDialog = ref(0);
const forfaitDialog = ref(null);
const forfaitid = ref(0);
const isLoading = ref(true);
const forfaitRef = ref(null);
const forfaitRefM = ref(null);

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const reloadKey1 = ref(0);
const reloadKey2 = ref(0);
const reloadKey3 = ref(0);
const reloadKey4 = ref(0);
const chooseM = ref(0);
const recapKey = ref(0);

//defineEmits(['switchToEtape1']);
const emit = defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);

const recapComponent = ref(null);
recapComponent.value = Etape5Recap;

const forfaitComponent = ref(null);
forfaitComponent.value = Etape2Forfait;

const forfaitMultiligneComponent = ref(null);
const forfaitAddComponent1 = ref(null);
const forfaitAddComponent2 = ref(null);
const forfaitAddComponent3 = ref(null);
const forfaitAddComponent4 = ref(null);

const isEnabled = ref(false); // false = désactivé, true = activé

const loadNext = () => {
  emit('switchToEtape3');
};

function enableSelect() {
  isEnabled.value = true
}

function loadMultiligne1() {
  //console.log('loadMultiligne1');
  props.parcours.multiligne = 1
  forfaitAddComponent1.value = Etape2Multiligne;
};

function loadMultiligne2() {
  //console.log('loadMultiligne2');
  props.parcours.multiligne = 2
  forfaitAddComponent2.value = Etape2Multiligne;
};

const loadMultiligne3 = () => {
  //console.log('loadMultiligne3');
  props.parcours.multiligne = 3;
  forfaitAddComponent3.value = Etape2Multiligne;
};

function loadMultiligne4() {
  //console.log('loadMultiligne4');
  props.parcours.multiligne = 4;
  forfaitAddComponent4.value = Etape2Multiligne;
};

const loadChooseMultiligne = () => {
  //console.log('loadChooseMultiligne');
  forfaitMultiligneComponent.value = Etape2ChooseMultiligne;
};

const taggageForfait = computed(() => {

  var tag = { tealium_event: 'product_click',
              offre_id: [props.parcours.forfait],
              offre_marque: ['orange'],
              offre_type: ['offre_forfait'],
              offre_modele: ['moi'],
              offre_qte: [1],
              offre_libelle: [],
              offre_prix_ttc: []
            };

  var who = ['moi','tiers']
  // On vérifie que forfaitRef et data_etape2 existent
  if (!forfaitRef.value || !forfaitRef.value.data_etape2) {
    return tag; // retourne l'objet initial vide ou partiel
  }

  const forfait = forfaitRef.value.data_etape2.forfaits[props.parcours.forfait];
  tag.offre_libelle.push((forfait.field_internet + 'go').replace(/\s+/g, '_'));
  tag.offre_prix_ttc.push(forfait.field_prix_forfait);

  // Parcours de multilignes
  Object.values(props.parcours.multilignes).forEach(item => {
    if (item.forfait > 0) {
      const existingIndex = tag.offre_id.findIndex((id, idx) => {
        return id === item.forfait && tag.offre_modele[idx] === who[item.who];
      });
      //console.log('forfait:'+item.forfait+'/'+existingIndex);

      if (existingIndex <= 0) {
        tag.offre_id.push(item.forfait);
        tag.offre_qte.push(1);
        tag.offre_modele.push(who[item.who]);
        tag.offre_marque.push('orange');
        tag.offre_type.push('offre_forfait');

        // Vérifie que la clé existe dans forfaits
        const forfaitData = forfaitRefM.value.data_etape2.forfaits[item.forfait];
        if (forfaitData) {
          tag.offre_libelle.push((forfaitData.field_internet + 'go').replace(/\s+/g, '_'));
          tag.offre_prix_ttc.push(forfaitData.field_prix_forfait);
        } else {
          // valeur par défaut si non trouvée
          tag.offre_libelle.push('inconnu');
          tag.offre_prix_ttc.push(0);
        }

      } else {
        tag.offre_qte[existingIndex] += 1;
      }

    }

    return tag;


  });


 return tag;

});

const deleteMultiligne1 = () => {
  //console.log('deleteMultiligne1:'+props.parcours.multiligne);
  if (props.parcours.multiligne == 4) {
    props.parcours.multilignes.multiligne1.forfait = props.parcours.multilignes.multiligne2.forfait;
    props.parcours.multilignes.multiligne1.who = props.parcours.multilignes.multiligne2.who;
    props.parcours.multilignes.multiligne2.forfait = props.parcours.multilignes.multiligne3.forfait;
    props.parcours.multilignes.multiligne2.who = props.parcours.multilignes.multiligne3.who;
    props.parcours.multilignes.multiligne3.forfait = props.parcours.multilignes.multiligne4.forfait;
    props.parcours.multilignes.multiligne3.who = props.parcours.multilignes.multiligne4.who;
    props.parcours.multilignes.multiligne4.forfait = 0;
    props.parcours.multilignes.multiligne4.who = 0;
    forfaitAddComponent4.value = null;
    forfaitAddComponent3.value = Etape2Multiligne;
    forfaitAddComponent2.value = Etape2Multiligne;
    forfaitAddComponent1.value = Etape2Multiligne;
  }
  if (props.parcours.multiligne == 3) {
    props.parcours.multilignes.multiligne1.forfait = props.parcours.multilignes.multiligne2.forfait;
    props.parcours.multilignes.multiligne1.who = props.parcours.multilignes.multiligne2.who;
    props.parcours.multilignes.multiligne2.forfait = props.parcours.multilignes.multiligne3.forfait;
    props.parcours.multilignes.multiligne2.who = props.parcours.multilignes.multiligne3.who;
    props.parcours.multilignes.multiligne3.forfait = 0;
    props.parcours.multilignes.multiligne3.who = 0;
    forfaitAddComponent3.value = null;
    forfaitAddComponent2.value = Etape2Multiligne;
    forfaitAddComponent1.value = Etape2Multiligne;
  }
  if (props.parcours.multiligne == 2) {
    props.parcours.multilignes.multiligne1.forfait = props.parcours.multilignes.multiligne2.forfait;
    props.parcours.multilignes.multiligne1.who = props.parcours.multilignes.multiligne2.who;
    props.parcours.multilignes.multiligne2.forfait = null;
    props.parcours.multilignes.multiligne2.who = null;
    forfaitAddComponent2.value = null;
    forfaitAddComponent1.value = Etape2Multiligne;
  }
  if (props.parcours.multiligne == 1) {
    disableMultiligne();
  }

  reloadKey1.value++;
  reloadKey2.value++;
  reloadKey3.value++;
  reloadKey4.value++;
};

const deleteMultiligne2 = () => {
  //console.log('deleteMultiligne2:'+props.parcours.multiligne);
  if (props.parcours.multiligne == 4) {
    props.parcours.multilignes.multiligne2.forfait = props.parcours.multilignes.multiligne3.forfait;
    props.parcours.multilignes.multiligne2.who = props.parcours.multilignes.multiligne3.who;
    props.parcours.multilignes.multiligne3.forfait = props.parcours.multilignes.multiligne4.forfait;
    props.parcours.multilignes.multiligne3.who = props.parcours.multilignes.multiligne4.who;
    props.parcours.multilignes.multiligne4.forfait = 0;
    props.parcours.multilignes.multiligne4.who = 0;
    forfaitAddComponent4.value = null;
    forfaitAddComponent3.value = Etape2Multiligne;
    forfaitAddComponent2.value = Etape2Multiligne;
  }
  if (props.parcours.multiligne == 3) {
    props.parcours.multilignes.multiligne2.forfait = props.parcours.multilignes.multiligne3.forfait;
    props.parcours.multilignes.multiligne2.who = props.parcours.multilignes.multiligne3.who;
    props.parcours.multilignes.multiligne3.forfait = 0;
    props.parcours.multilignes.multiligne3.who = 0;
    props.parcours.multilignes.multiligne4.forfait = 0;
    props.parcours.multilignes.multiligne4.who = 0;
    forfaitAddComponent4.value = null;
    forfaitAddComponent3.value = null;
    forfaitAddComponent2.value = Etape2Multiligne;
  }
  if (props.parcours.multiligne == 2) {
    props.parcours.multilignes.multiligne2.forfait = 0;
    props.parcours.multilignes.multiligne2.who = 0;
    forfaitAddComponent4.value = null;
    forfaitAddComponent3.value = null;
    forfaitAddComponent2.value = null;
  }
  props.parcours.multiligne = props.parcours.multiligne - 1;
  reloadKey1.value++;
  reloadKey2.value++;
  reloadKey3.value++;
  reloadKey4.value++;
};

const deleteMultiligne3 = () => {
  //console.log('deleteMultiligne3:'+props.parcours.multiligne);
  if (props.parcours.multiligne == 4) {
    props.parcours.multilignes.multiligne3.forfait = props.parcours.multilignes.multiligne4.forfait;
    props.parcours.multilignes.multiligne3.who = props.parcours.multilignes.multiligne4.who;
    props.parcours.multilignes.multiligne4.forfait = 0;
    props.parcours.multilignes.multiligne4.who = 0;
    forfaitAddComponent4.value = null;
    forfaitAddComponent3.value = Etape2Multiligne;
  }
  if (props.parcours.multiligne == 3) {
    props.parcours.multilignes.multiligne3.forfait = 0;
    props.parcours.multilignes.multiligne3.who = 0;
    forfaitAddComponent3.value = null;
  }
  props.parcours.multiligne = props.parcours.multiligne - 1;
  reloadKey2.value++;
  reloadKey3.value++;
  reloadKey4.value++;
};

const deleteMultiligne4 = () => {
  //console.log('deleteMultiligne4:'+props.parcours.multiligne);
  props.parcours.multilignes.multiligne4.forfait = 0;
  props.parcours.multilignes.multiligne4.who = 0;
  forfaitAddComponent4.value = null;
  props.parcours.multiligne = props.parcours.multiligne - 1;
  reloadKey3.value++;
};

function disableMultiligne() {
  //console.log('disableMultiligne');
  props.parcours.multilignes.multiligne4.forfait = 0;
  props.parcours.multilignes.multiligne4.who = 0;
  props.parcours.multilignes.multiligne3.forfait = 0;
  props.parcours.multilignes.multiligne3.who = 0;
  props.parcours.multilignes.multiligne2.forfait = 0;
  props.parcours.multilignes.multiligne2.who = 0;
  props.parcours.multilignes.multiligne1.forfait = 0;
  props.parcours.multilignes.multiligne1.who = 0;
  forfaitAddComponent4.value = null;
  forfaitAddComponent3.value = null;
  forfaitAddComponent2.value = null;
  forfaitAddComponent1.value = null;
  props.parcours.multiligne = 0;
  reloadKey1.value++;
  reloadKey2.value++;
  reloadKey3.value++;
  reloadKey4.value++;
  chooseM.value++;
};

function back() {
  //console.log('back');
  disableMultiligne();
  emit('switchToEtape1');
};

function jsModale() {
  const modale = document.querySelector('.jsModale');
  modale.showModal();
  modale.querySelector('.jsModaleClose').addEventListener('click', closeModale);
}

function closeModale(e) {
  const modale = e.currentTarget.parentElement.parentElement;
  modale.close();
  e.target.removeEventListener('click', closeModale);
}

function loadDialog(event) {
  var forfait = event.target;
  forfaitid.value = forfait.dataset.forfaitid;
  etapeDialog.value++;
  forfaitDialog.value = Etape2ForfaitDialog;
};

onMounted(async () => {
  try {
    props.parcours.etape = 2;
    // document.body.scrollTo({ top: 0, behavior: 'smooth' });
    // window.scrollTo({
    //   top: 0,
    //   behavior: 'smooth' // ou 'auto' si tu veux instantané
    // });
  } catch (e) {
    error_etape2.value = e.message;
  } finally {
    isLoading.value = false;
  }
});

</script>
